<div class="okc-sidebar-content">
  <div class="okc-nav-main">
    <span class="okc-logo">
      <img
        src="assets/okcargo-isologo.min.svg"
        alt="okcargo"
      />
    </span>

    <!-- TODO review and implement badge feature -->
    @for (section of sections; track section.path) {
      <div class="okc-vertical-button">
        <button
          matIconButton
          [routerLink]="section.path"
          routerLinkActive="active"
          [matBadge]="notificationDashboardCount()"
          matBadgeColor="warn"
          matBadgePosition="after"
          [matBadgeHidden]="notificationDashboardCount() === 0"
        >
          <mat-icon>{{ section.icon }}</mat-icon>
        </button>
        <span class="button-label">{{ section.label }}</span>
      </div>
    }
  </div>

  @if (account$ | async) {
    <div class="okc-nav-user">
      <mat-menu
        #userMenu="matMenu"
        yPosition="above"
      >
        <div class="okc-menu-subtitle">
          Hola, {{ (account$ | async)?.firstName }} {{ (account$ | async)?.lastName }}
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>Configuración de usuario</span>
        </button>
        <button
          mat-menu-item
          (click)="logout()"
        >
          <mat-icon>logout</mat-icon>
          <span>Cerrar sesión</span>
        </button>
      </mat-menu>
      <div class="okc-vertical-button">
        <button
          matIconButton
          [matMenuTriggerFor]="userMenu"
        >
          <mat-icon>account_circle</mat-icon>
        </button>
        <span class="button-label">{{ (account$ | async)?.firstName }} {{ (account$ | async)?.lastName }}</span>
      </div>
    </div>
  }
</div>
